/**
 * Xil to'liq nomi — autoGroup'da name=prefiks, value=qoldiq.
 * "енергия акумлятор" + "передни КИОНЕ" → "енергия акумлятор передни КИОНЕ".
 * value bo'sh bo'lsa — faqat name. value name bilan boshlansa — takrorlanmaydi.
 */
export function buildVariantLabel(variant) {
    const base = typeof variant.name === 'string' ? variant.name.trim() : '';
    const val = typeof variant.value === 'string' ? variant.value.trim() : '';
    if (val === '')
        return base;
    if (base === '')
        return val;
    if (val.toLowerCase().startsWith(base.toLowerCase()))
        return val;
    return `${base} ${val}`.replace(/\s+/g, ' ').trim();
}
/**
 * Product.variants (JSONB, ishonchsiz) → CatalogVariantDto[] (public, lean).
 *
 * - Array bo'lmasa yoki bo'sh bo'lsa → [] (oddiy mahsulot, xilsiz).
 * - `index` = Product.variants[] pozitsiyasi — checkout shu bilan xilni tanlaydi.
 * - narx: xil.price (>0) yoki ota-mahsulot narxi (fallback). cost EMAS.
 * - bo'sh label'li (name+value yo'q) xillar o'tkazib yuboriladi.
 * - `priceRate`: valyuta → UZS kursi (USD→usdRate, ...). parentPrice ham xil narxi ham
 *   PRODUCT valyutasida keladi; ikkalasi rate'ga ko'paytirilib UZS som'ga aylanadi
 *   (butun songa yaxlitlanadi — som tiyinsiz). Default 1 (UZS, konversiyasiz).
 */
export function mapProductVariantsToCatalog(raw, parentPrice, priceRate = 1) {
    if (!Array.isArray(raw))
        return [];
    const out = [];
    raw.forEach((entry, index) => {
        if (typeof entry !== 'object' || entry === null)
            return;
        const variant = entry;
        const label = buildVariantLabel(variant);
        if (label === '')
            return;
        const rawPrice = variant['price'];
        const basePrice = typeof rawPrice === 'number' && rawPrice > 0 ? rawPrice : parentPrice;
        const priceNum = Math.round(basePrice * priceRate);
        const rawStock = variant['stock'];
        const stock = typeof rawStock === 'number' && Number.isFinite(rawStock)
            ? Math.max(0, Math.floor(rawStock))
            : 0;
        const rawImages = variant['images'];
        const images = Array.isArray(rawImages) ? rawImages : [];
        const image = typeof images[0] === 'string' && images[0].length > 0 ? images[0] : null;
        const rawSku = variant['sku'];
        const sku = typeof rawSku === 'string' && rawSku.trim() !== '' ? rawSku.trim() : null;
        out.push({ index, label, sku, price: String(priceNum), inStock: stock, image });
    });
    return out;
}
//# sourceMappingURL=catalog-variants.js.map